import React from 'react';
import { api, extractErr } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { toast } from 'sonner';

export function AccountDialog({ open, onOpenChange, user }) {
  const [cur, setCur] = React.useState('');
  const [nw, setNw] = React.useState('');
  React.useEffect(() => { if (open) { setCur(''); setNw(''); } }, [open]);
  const save = async () => {
    try { const { data } = await api.post('/auth/change-password', { current_password: cur, new_password: nw }); if (data.access_token) localStorage.setItem('verse_token', data.access_token); toast.success('Password changed'); onOpenChange(false); }
    catch (e) { toast.error(extractErr(e, 'Could not change password.')); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="account-dialog">
        <DialogHeader><DialogTitle>{user?.name || 'Account'}</DialogTitle><DialogDescription>{user?.email} · {user?.role}</DialogDescription></DialogHeader>
        {user?.role === 'reviewer'
          ? <p className="text-sm text-slate-500">This review account's password is managed by the clinic.</p>
          : (
            <div className="space-y-3">
              <Input type="password" placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="account-current-password" />
              <Input type="password" placeholder="New password (min 8)" value={nw} onChange={(e) => setNw(e.target.value)} data-testid="account-new-password" />
            </div>
          )}
        {user?.role !== 'reviewer' && <DialogFooter><Button onClick={save} disabled={!cur || nw.length < 8} data-testid="account-save">Change password</Button></DialogFooter>}
      </DialogContent>
    </Dialog>
  );
}
